import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "../tableComponent";
import config from '../../config'

class Component extends TableComponent {

  resetOnMount = true

  makeColumns = () => {
    return [
      {
        Header: "Date",
        accessor: "chargeback_date",
        minWidth: 60,
        Cell: props => 
          <div>{moment(props.value*1000).format("D MMM YYYY, HH:mm:ss")}</div>,
        Footer: props => <span>{this.props.total.count || 0}</span>
      }, {
        Header: "Email",
        accessor: "email",
        minWidth: 60,
      }, {
        Header: "Name",
        accessor: "name",
        minWidth: 60,
      }, {
        Header: "Mid",
        accessor: "support_site",
        minWidth: 50,
      }
    ]
  }

  apiPath = "hookupbay/chargebacks"

  tableParams = {
    manual: true,
    sorted: [{
      id: "chargeback_date",
      desc: true
    }],
    showAll: false
  }

  render() {
    return (
      <div>
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"hookupbay_chargebacks")

